(function () {
  'use strict';
  if (window.gfCardCartReady) return;
  window.gfCardCartReady = true;
  var selector = '#gf-products .gf-wps-product-card .gf-card-cart-form, .native-purchase-card .gf-card-cart-form';
  // Delegation survives Globo filtering, pagination and replacement of the grid.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gf-quantity]');
    if (!button || !button.closest(selector)) return;
    event.preventDefault();
    var form = button.closest('form');
    if (form.dataset.busy) return;
    var input = form.elements.quantity;
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.gfQuantity));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form.matches(selector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.busy || !form.reportValidity()) return;
    var quantity = Number(form.elements.quantity.value);
    if (!Number.isSafeInteger(quantity) || quantity < 1) return;
    var button = form.querySelector('[type="submit"]');
    var status = form.querySelector('.gf-card-cart-status');
    var cartLink = form.querySelector('.gf-card-view-cart');
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = 'Adding…';
    status.textContent = '';
    status.removeAttribute('data-error');
    cartLink.hidden = true;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : new URL(form.action).pathname.replace(/cart\/add$/, '');
    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: form.elements.id.value, quantity: quantity }] })
      });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please check its availability.');
      status.textContent = 'Added to cart.';
      cartLink.hidden = false;
      // The existing mini-cart trigger fetches fresh contents when opened.
      if (window.dTGeneral && typeof window.dTGeneral.showMiniCart === 'function' && document.querySelector('.dT_MiniCartModelBtn')) {
        try { window.dTGeneral.showMiniCart(); } catch (error) { /* View cart remains available. */ }
      }
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) throw new Error('Cart refresh failed');
        return res.json();
      }).then(function (cart) {
        document.querySelectorAll('.CartCount').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () { /* The successful addition is not retried. */ });
    } catch (error) {
      status.setAttribute('data-error', 'true');
      status.textContent = error.message || 'Unable to confirm the addition. Check your cart before trying again.';
      cartLink.hidden = false;
    } finally {
      delete form.dataset.busy;
      form.removeAttribute('aria-busy');
      button.disabled = false;
      button.textContent = 'Add to Cart';
    }
  }, true);
}());
